import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b8d4516b5d6f0014197c0d/otek1_syber/node_modules/next/dist/client/components/client-page.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b8d4516b5d6f0014197c0d/otek1_syber/node_modules/next/dist/client/components/client-segment.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b8d4516b5d6f0014197c0d/otek1_syber/node_modules/next/dist/client/components/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b8d4516b5d6f0014197c0d/otek1_syber/node_modules/next/dist/client/components/http-access-fallback/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b8d4516b5d6f0014197c0d/otek1_syber/node_modules/next/dist/client/components/layout-router.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b8d4516b5d6f0014197c0d/otek1_syber/node_modules/next/dist/client/components/render-from-template-context.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b8d4516b5d6f0014197c0d/otek1_syber/node_modules/next/dist/lib/metadata/metadata-boundary.js");
